import { IonBackButton } from '@ionic/react';
import React from 'react';
import { t } from 'ttag';

import Platform from '@custom-types/Platform';
import { Capacitor } from '~capacitor-plugins/core';

const BackButton = () => {
  const platform = Capacitor.getPlatform();

  return (
    <IonBackButton data-testid="ionic-back-btn" text={platform === Platform.Ios ? t`Back` : ''} />
  );
};

export default BackButton;
